import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
const pinia = createPinia();
import router from "./router";
import vuetify from "./plugins/vuetify";
// import { loadFonts } from "./plugins/webfontloader";
import baseplugin from "./plugins/baseplugin";
import windowSizePlugin from "./plugins/windowSizePlugin";
import "./assets/fonts.css";
//loadFonts();

createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(baseplugin)
  .use(windowSizePlugin)
  .mount("#app");
